import { ErrorMessage } from "components/ErrorMessage/ErrorMessage.style";
import { env } from "config";
import React, { useState } from "react";

var ReCAPTCHA = import("react-google-recaptcha");

const Recaptcha = ({ size, onChange, sitekey, ...props }) => {
  const recaptchaRef = React.createRef();
  const [LoadedRecaptcha, setLoadedRecaptcha] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(null);

  function changeHandle(value) {
    onChange(value);
  }

  function expiredHandle(widgetId) {
    recaptchaRef.current.reset(widgetId);
  }
  ReCAPTCHA.then((module) => setLoadedRecaptcha(() => module.default)).catch(
    (err) => setRecaptchaError(err)
  );

  if (recaptchaError) {
    return (
      <ErrorMessage center>
        Desculpe, ocorreu um erro inesperado, tente novamente mais tarde.
      </ErrorMessage>
    );
  }
  return (
    LoadedRecaptcha && (
      <LoadedRecaptcha
        ref={recaptchaRef}
        size={size}
        sitekey={sitekey || env.RE_CAPTCHA_SITE_KEY}
        onExpired={expiredHandle}
        badge="bottomright"
        {...props}
        onChange={changeHandle}
      />
    )
  );
};

export default Recaptcha;
